import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";

import "./Articles.css";
import useFetch from "./ApiClient/GetApi";

export default function FeaturedAccordion({data}) {
  // console.log(data)
//  const { apiData: homeRes, loading: homeLoading } = useFetch("/user/homeData");
  // console.log(homeRes)
  // Optional fallback (used only if API has nothing)
  const staticFallbackTabs = [/* ← keep your existing array here if you want a fallback */];

  const KEY_ORDER = ["topPicks", "foodies", "eyeout", "budget"];
  const KEY_META = {
    topPicks: { num: "01", label: "TOP PICKS", tabColor: "fp-tab-foodies", tabText: "TOP PICKS", bgColor: "#cdb8e3" },
    foodies: { num: "02", label: "FOR THE FOODIE", tabColor: "fp-tab-foodies", tabText: "FOR THE FOODIES", bgColor: "rgb(238, 212, 223)" },
    eyeout: { num: "03", label: "KEEP AN EYE OUT", tabColor: "fp-tab-eye", tabText: "KEEP AN EYE OUT", bgColor: "rgb(207, 221, 232)" },
    budget: { num: "04", label: "ON A BUDGET", tabColor: "fp-tab-budget", tabText: "ON A BUDGET", bgColor: "#dbe5cd" },
  };
const tagClassFor = (name = "") => {
  const n = name.toLowerCase();
  if (n.includes("tech")) return "tech";
  if (n.includes("life")) return "lifestyle";
  if (n.includes("shop")) return "shopping";
  if (n.includes("transport")) return "transport";
  if (n.includes("news")) return "news";
  return "news"; // default class
};

  const tagForAll = "LIFESTYLE"; // or "NEWS"—adjust to your taxonomy
  const hrefOf = (n) => (n?.id ? `/articles/${n.slug}` : "/articles");
  const imgOr = (n, fb) => (n?.thumbnail || fb);
  const [activeTab, setActiveTab] = useState(0);

  // 🔹 Fetch home data (contains data.topPicks)
 

  // 🔹 Pull and group news by key
  const grouped = useMemo(() => {
    const arr = data || [];
    const g = { topPicks: [], foodies: [], eyeout: [], budget: [] };
    arr.forEach((row) => {
      if (row?.key && g[row.key] && row.news) g[row.key].push(row.news);
    });
    return g;
  }, [data]);

  // 🔹 Convert each group into your tab structure:
  // main: first item, sideCards: next 2, news list: next 4 (adjust as you like)
const tabsFromApi = useMemo(() => {
  const built = KEY_ORDER.map((key) => {
    const items = grouped[key] || [];
    if (!items.length) return null;

    const main = items[0];
    const side = items.slice(1, 3);
    const list = items.slice(3, 7);

    const meta = KEY_META[key];

    // 🔹 NEW: derive tag from main item's category
    const catName = main?.category?.name || "News";
    const tagText = catName.toUpperCase();
    const tagClass = tagClassFor(catName);

    return {
      num: meta.num,
      label: meta.label,
      // ⬇️ use category name instead of hardcoded tag
      tag: tagText,
      tagClass,                 // <- keep class for styling
      image: imgOr(main, "/13.jpg"),
      title: main?.title || "—",
      slug: main?.slug || "—",
      sideCards: side.map((n) => ({
        image: imgOr(n, "/14.jpg"),
        title: n?.title || "—",
        slug: n?.slug || "—",
        href: hrefOf(n),
      })),
      news: list.map((n) => ({
        title: n?.title || "—",
        slug: n?.slug || "—",
        meta: n?.user?.name || "",
        href: hrefOf(n),
      })),
      tabColor: meta.tabColor,
      tabText: meta.tabText,
      bgColor: meta.bgColor,
      labelBgColor: meta.bgColor,
      href: hrefOf(main),
    };
  }).filter(Boolean);

  return built.length ? built : staticFallbackTabs;
}, [grouped]);


  const handleTabHover = (idx) => setActiveTab(idx);

  return (
    <section className="section-block elementor-horizontal-accordion">
      <div className="elementor-accordion-row">
        {/* Optional tiny loading hint */}
        {!data && (
          <div className="p-3 text-muted">Loading top picks…</div>
        )}

        {tabsFromApi.map((tab, idx) => (
          <div
            key={`${tab.num}-${tab.label}`}
            className={`elementor-accordion-tab${activeTab === idx ? ' active' : ''} ${tab.tabColor}`}
            onMouseEnter={() => handleTabHover(idx)}
            onClick={() => handleTabHover(idx)}
            style={{
              display: 'flex',
              flexDirection: 'row',
              background: tab.bgColor,
              opacity: 1,
              transition: 'background 0.3s, opacity 0.3s',
            }}
          >
            <div
              className={`elementor-accordion-label${activeTab === idx ? ' sidebar-label' : ''}`}
              style={{
                background: tab.labelBgColor ? tab.labelBgColor : tab.bgColor,
                color: '#222',
                borderRadius: activeTab === idx ? '16px 0 0 16px' : '16px',
                transition: 'background 0.3s, opacity 0.3s',
                opacity: 1,
              }}
            >
              <div className="elementor-accordion-num">{tab.num}</div>
              <div className="elementor-accordion-text">{tab.label}</div>
            </div>

            {activeTab === idx && (
              <div className="tab-content-grid">
                {/* Main Feature Card */}
                <div
                  className="tab-main-feature"
                  style={{ backgroundImage: `url('${tab.image}')` }}
                >
                   <span className={`tag ${tab.tagClass}`}>{tab.tag}</span>
                  <Link  to={`/article/${tab.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div className="tab-main-title">{tab.title}</div>
                  </Link>
                </div>

                {/* Side Cards */}
                <div className="tab-side-cards">
                  {tab.sideCards?.map((card, i) => (
                    <div
                      className="tab-side-card"
                      key={i}
                      style={{ backgroundImage: `url('${card.image}')` }}
                    >
                      <Link to={`/article/${card.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        <div className="tab-side-title">{card.title}</div>
                      </Link>
                    </div>
                  ))}
                </div>

                {/* News List */}
                <div className="tab-news-list">
                  {tab.news?.map((item, i) => (
                    <div className="tab-news-item" key={i}>
                      <Link to={`/article/${item.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        <div className="tab-news-title">{item.title}</div>
                      </Link>
                      {item.meta ? (
                        <div className="tab-news-meta">{item.meta}</div>
                      ) : null}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
